import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
    selector: 'mmoga-event-logs',
    imports: [
        RouterOutlet,
        RouterLink,
        RouterLinkActive
    ],
    templateUrl: './event-logs.component.html',
    standalone: true,
    styleUrl: './event-logs.component.scss'
})
export class EventLogsComponent {
    private router = inject(Router);


    isActive(tabRoute: string): boolean {
        const current = this.router.url.split('/').pop();
        return current === tabRoute;
    }
}
